import { useTrackingContext } from '@zapier/toolbox-tracking';
import { EventData, EventName } from 'tracking/events';

type TrackEvent = <K extends EventName>(
  eventName: K,
  data: EventData<K>,
) => void;

/**
 * Wrap useTrackingContext and expose only the strongly typed trackEvent
 * All trackEvent usages should flow through this rather than using useTrackingContext() directly
 */
export const useTrackEvent = (): TrackEvent => {
  const { trackEvent } = useTrackingContext();
  return trackEvent;
};
